import { Button, InlineStack } from "@shopify/polaris";
import { DatabaseIcon, DeliveryIcon, InventoryIcon, OrderIcon, ProductIcon } from "@shopify/polaris-icons";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import agent from "../../app/api/agent";
import type { AtdDiagnostics } from "../../app/models/Atd";
import VendorIntegrationCard from "./VendorIntegrationCard";

const AtdIntegrationSettings: React.FC = () => {
    const navigate = useNavigate();
    const [diagnostics, setDiagnostics] = useState<AtdDiagnostics>();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string>();
    const [attempt, setAttempt] = useState(0);
    const accountConnected = Boolean(diagnostics?.profileConfigured && !error);
    useEffect(() => {
        let mounted = true;
        setLoading(true);
        setError(undefined);
        agent.Atd.diagnostics()
            .then((result) => { if (mounted) setDiagnostics(result); })
            .catch(() => {
                if (!mounted) return;
                setDiagnostics(undefined);
                setError("Unable to load ATD connection. Try again.");
            })
            .finally(() => { if (mounted) setLoading(false); });
        return () => { mounted = false; };
    }, [attempt]);

    const openProfile = () => navigate("/integrations/atd/profile");
    const location = diagnostics?.locationNumber ? `Location ${diagnostics.locationNumber} · ` : "";
    return (
        <VendorIntegrationCard
            id="atd-vendor"
            title="American Tire Distributors"
            status={loading ? "loading" : error ? "error" : accountConnected ? "connected" : "disconnected"}
            description="Connect your ATD account for product data, inventory, and ship-to-home fulfillment."
            capabilities={[
                { label: "Product catalog", icon: ProductIcon },
                { label: "Inventory", icon: InventoryIcon },
                { label: "Fitment data", icon: DatabaseIcon },
                { label: "Ship-to-home", icon: DeliveryIcon },
                { label: "Fulfillment tracking", icon: OrderIcon },
            ]}
            action={{
                label: loading ? "Checking…" : error ? "Retry connection check" : accountConnected ? "Manage connection" : "Connect ATD",
                onAction: error ? () => setAttempt(current => current + 1) : openProfile,
            }}
            footer={loading ? "Checking ATD connection status." : error || (accountConnected ? `${location}${diagnostics?.profileActive ? "Sync is enabled" : "Sync is disabled"}` : "Requires an ATD account")}
            configuration={{ label: "Configure integration", onAction: openProfile }}
        >
            {accountConnected && !loading && <InlineStack gap="300">
                <Button onClick={() => navigate("/integrations/atd/orders")}>Open orders</Button>
                <Button onClick={() => navigate("/integrations/atd/preview")}>Preview order</Button>
            </InlineStack>}
        </VendorIntegrationCard>
    );
};
export default AtdIntegrationSettings;
